module.exports = __webpack_public_path__ + "img/img_digthread8x11.036d7e2b.png";